import { freeze } from '@rehaje/shared'

export const defaultLocales = freeze({
  index: '当前行序号',
  item: '当前行数据',
  rollup: '父级行数据'
})
